export default "__VITE_ASSET__jBFleH8a__"